export const VALIDIC_CONSENT = 'validic-collect-v1';
export const VITALL_CONSENT = 'vitall-PII-v1';
export const TERRA_CONSENT = 'terra-consent';
export const DISCLOSURE_AUTH_CONSENT = 'disclosure-authorization-document';
